// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_18_1-loader,
.perxis-auto-1_18_1-loader-wrapper {
  /* Z-index */
  --perxis-auto-loader-first-z-index-inner: var(--perxis-auto-loader-first-z-index, 1035);
  --perxis-auto-loader-second-z-index-inner: var(--perxis-auto-loader-second-z-index, 1040);
  /* End Z-index */
  /* Colors */
  --perxis-auto-loader-first-color-inner: var(--perxis-auto-loader-first-color, #c5c5c5);
  --perxis-auto-loader-second-color-inner: var(--perxis-auto-loader-second-color, var(--perxis-auto-root-seventh-color-inner));
  /* End Colors */
}

.perxis-auto-1_18_1-loader.ant-5_24_1-spin .ant-5_24_1-spin-dot-item {
  opacity: 1;
  animation: none;
  background-color: var(--perxis-auto-loader-first-color-inner);
}

.perxis-auto-1_18_1-loader-wrapper.ant-5_24_1-spin-nested-loading > div > .perxis-auto-1_18_1-loader {
  max-height: none;
  z-index: var(--perxis-auto-loader-second-z-index-inner);
}
.perxis-auto-1_18_1-loader-wrapper .ant-5_24_1-spin-container.ant-5_24_1-spin-blur {
  z-index: var(--perxis-auto-loader-first-z-index-inner);
}
.perxis-auto-1_18_1-loader-wrapper .ant-5_24_1-spin-container::after {
  background: var(--perxis-auto-loader-second-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
